import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {InfrastructureComponent} from "./infrastructure/infrastructure.component";
import {ItServiceComponent} from "./it-service/it-service.component";
import {StudentGrievanceComponent} from "./student-grievance/student-grievance.component";

const routes: Routes = [
    {path: 'infrastructure', component: InfrastructureComponent, data: {title: 'Infrastructure'}},
    {path: 'academic-facilities', component: InfrastructureComponent, data: {title: 'Academic Facilities'}},
    {path: 'campus-facilities', component: InfrastructureComponent, data: {title: 'Campus Facilities'}},
    {path: 'transportation', component: InfrastructureComponent, data: {title: 'Transportation'}},
    {path: 'residential-facilities', component: InfrastructureComponent, data: {title: 'Residential Facilities'}},
    {path: 'library', component: InfrastructureComponent, data: {title: 'Library'}},
    {path: 'schools', component: InfrastructureComponent, data: {title: 'Schools'}},
    {path: 'green-campus', component: InfrastructureComponent, data: {title: 'Green Campus'}},
    {path: 'ncc', component: InfrastructureComponent, data: {title: 'NCC'}},
    {
        path: 'extra-curricular-activities',
        component: InfrastructureComponent,
        data: {title: 'Extra Curricular Activities'}
    },
    {path: 'auditorium', component: InfrastructureComponent, data: {title: 'Auditorium'}},
    {path: 'it-services', component: ItServiceComponent, data: {title: 'IT Services'}},
    {path: 'student-grievance', component: StudentGrievanceComponent},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CampusLifeRoutingModule {
}
